import { ReactNode } from 'react'

import clsx from 'clsx'

import s from './styles.module.scss'

export type BadgeColor = 'blue' | 'green' | 'black' | 'gray'

interface Props {
  color?: BadgeColor
  children?: ReactNode
  className?: string
}

export const UmrahBadge = ({ color = 'blue', children, className }: Props) => {
  return (
    <span className={clsx(s.badge, s[color], className, 'semi-bold-11')}>
      {children}
    </span>
  )
}
